import { internalApiSlice, transformResponse } from "@redux/api/internalApiSlice";
import { Industry } from "@/types/general";

export const industriesApi = internalApiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getIndustries: builder.query<Industry.Root[], void>({
            query: () => ({
                url: `industries`,
            }),
            transformResponse
        }),
    })
});

export const {
    useGetIndustriesQuery
} = industriesApi;